import { useViewContext } from "@editor-providers";
import { useEffect } from "react";
import { TABS_SPEED } from "../constants";
import { useActive } from "../providers";
import type { TabTitleType, TabsPayload } from "../types";
import { useIntersection } from "./useIntersection";

export const useTabsAutoplay = ({
  settings,
  titles,
  id,
  isMobile,
}: {
  settings: TabsPayload;
  titles: TabTitleType[];
  id: string;
  isMobile: boolean;
}) => {
  const { setActive, active } = useActive();
  const { tabsAutoplay, tabsLoop, tabsSpeed } = settings;
  const { view } = useViewContext();
  const isIntersection = useIntersection({ id });
  useEffect(() => {
    if (tabsAutoplay && view === "default" && !isMobile && isIntersection) {
      const interval = setInterval(
        () => {
          const activeIndex = titles.findIndex((title) => title.id === active);
          const nextIndex = activeIndex + 1;
          let nextTab = titles[nextIndex];
          if (!nextTab && tabsLoop) nextTab = titles[0];
          else clearInterval(interval);
          if (nextTab) setActive(nextTab.id);
        },
        TABS_SPEED[tabsSpeed || "medium"],
      );
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabsAutoplay, tabsLoop, active, isIntersection]);
};
